import PrivacyPolicyZH from './privacy-policy/privacy-policy_zh';
import PrivacyPolicyJA from './privacy-policy/privacy-policy_ja';
import InformationSecurityZH from './information-security/information-security_zh';
import InformationSecurityJA from './information-security/information-security_ja';
import SplashZH from './splash/splash_zh';
import SplashJA from './splash/splash_ja';
import worksSources from './works';
import AboutZH from './about/about_zh';
import AboutJA from './about/about_ja';
import RecruitZH from './recruit/recruit_zh';
import RecruitJA from './recruit/recruit_ja';
import ServicesZH from './services/services_zh';
import ServicesJA from './services/services_ja';
import IFSZH from './ifs/ifs_zh';
import IFSJA from './ifs/ifs_ja';
import SIZH from './si/si_zh';
import SIJA from './si/si_ja';
import ERPZH from './erp/erp_zh';
import ERPJA from './erp/erp_ja';
import EAMZH from './eam/eam_zh';
import EAMJA from './eam/eam_ja';
import MESZH from './mes/mes_zh';
import MESJA from './mes/mes_ja';
import WMSZH from './wms/wms_zh';
import WMSJA from './wms/wms_ja';
import AIZH from './ai/ai_zh';
import AIJA from './ai/ai_ja';
import RobotZH from './robot/robot_zh';
import RobotJA from './robot/robot_ja';
import UIUXZH from './uiux/uiux_zh';
import UIUXJA from './uiux/uiux_ja';
import NavZH from './nav/nav_zh';
import NavJA from './nav/nav_ja';
import ContactUsZH from './contact-us/contact-us_zh';
import ContactUsJA from './contact-us/contact-us_ja';
import ThanksContactZH from './thanks-contact/thanks-contact_zh';
import ThanksContactJA from './thanks-contact/thanks-contact_ja';
import MetaZH from './meta/meta_zh.json';
import MetaJA from './meta/meta_ja.json';
import newsSources from './news';

const PageResources = {
  zh: {
    'privacy-policy': PrivacyPolicyZH,
    'information-security': InformationSecurityZH,
    splash: SplashZH,
    services: ServicesZH,
    ifs: IFSZH,
    si: SIZH,
    erp: ERPZH,
    eam: EAMZH,
    mes: MESZH,
    wms: WMSZH,
    ai: AIZH,
    robot: RobotZH,
    uiux: UIUXZH,
    works: worksSources.zh.meta,
    recruit: RecruitZH,
    about: AboutZH,
    nav: NavZH,
    'contact-us': ContactUsZH,
    'thanks-contact': ThanksContactZH,
    meta: MetaZH,
    news: newsSources.zh.meta,
  },
  ja: {
    'privacy-policy': PrivacyPolicyJA,
    'information-security': InformationSecurityJA,
    splash: SplashJA,
    services: ServicesJA,
    ifs: IFSJA,
    si: SIJA,
    erp: ERPJA,
    eam: EAMJA,
    mes: MESJA,
    wms: WMSJA,
    ai: AIJA,
    robot: RobotJA,
    uiux: UIUXJA,
    works: worksSources.ja.meta,
    recruit: RecruitJA,
    about: AboutJA,
    nav: NavJA,
    'contact-us': ContactUsJA,
    'thanks-contact': ThanksContactJA,
    meta: MetaJA,
    news: newsSources.ja.meta,
  },
};

const loadPageResources = async (locale) => {
  const nextResources = {
    ...PageResources,
    [locale]: {
      ...PageResources[locale],
    },
  };

  const worksSource = worksSources[locale];
  const newsSource = newsSources[locale];
  const [works, news] = await Promise.all([
    worksSource ? worksSource.load() : Promise.resolve(null),
    newsSource ? newsSource.load() : Promise.resolve(null),
  ]);

  if (worksSource) {
    nextResources[locale].works = works
      ? { ...worksSource.meta, ...works }
      : worksSource.meta;
  }

  if (newsSource) {
    nextResources[locale].news = news
      ? { ...newsSource.meta, ...news }
      : newsSource.meta;
  }

  return nextResources;
};

export { loadPageResources };

export default PageResources;
